module.exports = __webpack_public_path__ + "img/Skirt-Back-B10-Cc-back.202ac552.png";